export default __webpack_public_path__ + "static/media/homepage-lens.066bc736.jpg";